import * as crypto from "crypto-browserify";

export function createMD5hash(val: string) {
  return crypto.createHash("md5").update(val).digest("hex").toUpperCase();
}
